import React from "react";
import {Box, Chip, Paper, Stack, Typography} from "@mui/material";
import {WarningAmber} from "@mui/icons-material";
import type {Supplier360} from "../../supplier360DemoData";
import {formatDate, riskLevelColor} from "../../supplier360Utils";

type Props = { supplier: Supplier360 };

export const RisksTab: React.FC<Props> = ({supplier}) => {
    if (supplier.risks.length === 0) {
        return <Typography color="text.secondary">No active risks flagged for this supplier.</Typography>;
    }

    // Surface high risks first.
    const order = {high: 0, medium: 1, low: 2} as const;
    const sorted = [...supplier.risks].sort((a, b) => order[a.level] - order[b.level]);

    return <Box>
        {sorted.map(r => {
            const color = riskLevelColor(r.level);
            return <Paper key={r.id} variant="outlined" className="s360-item-card" sx={{p: 2}}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
                    <Stack direction="row" spacing={1.5} alignItems="flex-start">
                        <WarningAmber color={color} sx={{mt: 0.3}}/>
                        <Box>
                            <Typography variant="h3" sx={{fontSize: 15}}>{r.title}</Typography>
                            <Typography variant="caption" color="text.secondary">
                                {r.category} · detected {formatDate(r.detectedOn)}
                            </Typography>
                        </Box>
                    </Stack>
                    <Chip size="small" color={color} label={`${r.level.charAt(0).toUpperCase() + r.level.slice(1)} risk`}/>
                </Box>
                <Typography variant="body2" mt={1}>{r.detail}</Typography>
            </Paper>;
        })}
    </Box>;
};
